export default "__VITE_ASSET__CUHbV76t__"